import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable()

export class AuthService {
    token: string = '';

    constructor(private httpClient: HttpClient){
    }

    setToken(token){
        localStorage.setItem('token', token)
    }
    getToken(){
        return this.token
    }

    resetPassword(data){

        this.httpClient.post('/auth/login/', {email: data}).subscribe(data => {
        })
    }

}


// WEBPACK FOOTER //
// ./src/app/pages/auth.service.ts